import type { LanguageCode } from '../types/i18n';

export interface LanguageOption {
  value: LanguageCode;
  label: string;
  flag: string;
}

export const LANGUAGE_OPTIONS: LanguageOption[] = [
  { value: 'uz', label: "O'zbek", flag: '🇺🇿' },
  { value: 'ru', label: 'Русский', flag: '🇷🇺' },
  { value: 'en', label: 'English', flag: '🇬🇧' },
];

export const LANGUAGE_MAP: Record<LanguageCode, LanguageOption> = Object.fromEntries(
  LANGUAGE_OPTIONS.map((opt) => [opt.value, opt]),
) as Record<LanguageCode, LanguageOption>;
